/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationContractAttachmentsAliases {
  ACTION_DOWNLOAD = 'action-download',
  ACTION_REQUEST_CHANGE = 'action-request-change',
  AVATAR_0 = 'avatar-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_ATTACHMENTS = 'deck-attachments',
  FETCH_ATTACHMENTS = 'fetch-attachments',
  FIELD_2 = 'field-2',
  FIELD_COUNTER_OFFER = 'field-counter-offer',
  FIELD_MESSAGE_REQUEST_CHANGE = 'field-message-request-change',
  FORM_REQUEST_CHANGE = 'form-request-change',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  HPMS_TEXT_HTML_0 = 'hpms-text-html-0',
  MAPPER_0 = 'mapper-0',
  MODAL_REQUEST_CHANGE = 'modal-request-change',
  PANEL_0 = 'panel-0',
  PANEL_CONTRACT_ATTACHMENTS = 'panel-contract-attachments',
  PANEL_REQUEST_CHANGE = 'panel-request-change',
  TEXT_AREA_REQUEST_CHANGE = 'text-area-request-change',
}
export { NegotiationContractAttachmentsAliases };
